module.exports = __webpack_public_path__ + "img/4inPipe_I_small2-min.109dfc2a.png";